import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/build/products/Survey/layouts/default.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/app/build/products/Survey/layouts/public.vue").then(m => m.default || m))
}